import { css, cx } from '@eti/styles';
import { vars } from '@etg/wings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wingWrapperStyles = {
  base: css`
    height: 42px;
  `,
  borderColor: css`
    fill: ${vars.colors.inputs.border};
  `
};
const emptyRowStyles = css`
  height: 24px;
`;
const wingIcon = css`
  height: 60px;
  pointer-events: none;
  width: 30px;
`;
const Wing = ({
  isLeft,
  isRight,
  isEmptyRow
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: cx(wingWrapperStyles.base, {
      [emptyRowStyles]: isEmptyRow,
      [wingWrapperStyles.borderColor]: !isEmptyRow
    }),
    children: [isLeft && /*#__PURE__*/_jsx("svg", {
      className: wingIcon,
      "data-testid": "leftWing",
      viewBox: "0 0 64 128",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 32 V128 L64 96 V0 L0 32z"
      })
    }), isRight && /*#__PURE__*/_jsx("svg", {
      className: wingIcon,
      "data-testid": "rightWing",
      viewBox: "0 0 64 128",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0 V96 L64 128 V32 L0 0z"
      })
    })]
  });
};
export default Wing;
//# sourceMappingURL=Wing.js.map